import { S, singleQuiz, multiQuiz, opt } from './schema.js';

const ABC = (a, b, c) => [opt('A', a), opt('B', b), opt('C', c)];

export const NEBULOSA = {
  id: 'rede-nebulosa',
  order: 3,
  title: 'Rede Nebulosa',
  mission: 'Missão Rede Nebulosa',
  level: 'Avançado',
  courseLabel: 'Curso 3 de 3',
  kicker: 'Pré-requisito: certificado do Curso 2',
  startLabel: 'Entrar na nebula',
  nextCourseId: null,
  nextButtonLabel: 'Encerrar',
  certName: 'Curso 3 · Avançado · Missão Rede Nebulosa',
  certBody:
    'Carga: 30 slides · compartilhamento, transferência internacional, decisão automatizada, criança, sanção.',
  theme: 'nebula',
  slides: [
    S(
      1,
      'A rede é o produto',
      'teca-nebula',
      'Escudo e cofre guardam. A rede move. PDV, retaguarda, BI, cardápio, suporte, um SaaS lá fora. Cada pulo é tratamento. 20 minutos para não mandar a pessoa junto com o arquivo.',
      'Entrar na nebula',
      {
        type: 'hero',
        heading: 'Missão Rede Nebulosa',
        kicker: 'Curso 3 de 3',
        badge: 'fluxo entre planetas',
      },
    ),
    S(
      2,
      'A planilha que viajou',
      'teca-alerta',
      'Nexo viu: uma planilha de clientes saiu da Padaria Estrela, passou no e-mail pessoal, entrou num Drive de fornecedor, voltou num grupo. A Vaza não invadiu. A gente convidou.',
      'Vamos fechar o fluxo',
      {
        type: 'flow',
        steps: ['loja', 'e-mail pessoal', 'Drive do fornecedor', 'grupo'],
      },
      { nexo: true, vaza: true },
    ),
    S(
      3,
      'Compartilhar é tratar',
      'teca-explica',
      'Mandar para o contador, para o app de disparo, para o BI, para o parceiro de iFood: cada um é um compartilhamento. Precisa de motivo, de contrato quando for operador, de dado mínimo.',
      'Continuar',
      {
        type: 'nebula-map',
        center: 'loja',
        nodes: ['contador', 'cardápio', 'BI', 'suporte'],
      },
    ),
    S(
      4,
      'Operador não é “o cara de TI”',
      'teca-explica',
      'Operador trata por conta do controlador, no contrato. A Altec é operadora de muito dado de restaurante. O restaurante não “larga o dado e reza”. A gente também não usa o dado do cliente para um produto novo sem base e sem combinado.',
      'Continuar',
      {
        type: 'callout',
        body: 'Dúvida de produto: Encarregado antes do experimento.',
      },
    ),
    S(
      5,
      'Planilha, e-mail pessoal, grupo',
      'teca-alerta',
      'Os três atalhos da Vaza: CSV no e-mail, encaminhar para o Gmail pessoal “para trabalhar no fim de semana”, grupo de WhatsApp com gente que já saiu da empresa. Atalho não é processo.',
      'Continuar',
      {
        type: 'dont',
        items: [
          'CSV no e-mail solto',
          'Gmail pessoal no fim de semana',
          'Grupo com quem já saiu',
        ],
      },
      { vaza: true },
    ),
    S(
      6,
      'Fora do Brasil',
      'teca-nebula',
      'Nuvem em outro país é transferência internacional. A lei pede adequação, cláusulas-padrão ou outra garantia. Não é “está na AWS, então ok”. Quem contrata o SaaS pergunta ao jurídico / Encarregado antes de colar a base lá.',
      'Continuar',
      {
        type: 'transfer',
        from: 'Brasil',
        to: 'outro planeta',
        seal: 'cláusula / adequação',
      },
    ),
    S(
      7,
      'No seu posto',
      'teca-explica',
      'Antes de exportar: preciso? quem recebe? fica no Brasil? tem contrato? sei apagar depois? Se faltar um sim, não exporta.',
      'Continuar',
      {
        type: 'checklist',
        items: [
          'preciso?',
          'quem recebe?',
          'fica no Brasil?',
          'tem contrato?',
          'sei apagar depois?',
        ],
      },
    ),
    S(
      8,
      'Recap da mini-aula 1',
      'teca-explica',
      'Compartilhar é tratar. Operador trabalha no contrato. E-mail pessoal não é cofre. Nuvem fora do Brasil tem regra. Cinco sim antes de exportar.',
      'Me pergunta',
      {
        type: 'pills',
        items: [
          'compartilhar = tratar',
          'contrato',
          'e-mail pessoal não',
          'nuvem tem regra',
          'cinco sim',
        ],
      },
    ),
    S(
      9,
      'Pergunta 1',
      'teca-pensa',
      'Um parceiro pede “a base toda para testar a integração”. Você manda o CSV de produção?',
      'Ver a resposta',
      { type: 'quiz' },
      {
        prompt:
          'Um parceiro pede “a base toda para testar a integração”. Você manda o CSV de produção?',
        scored: singleQuiz({
          items: ['c3-q1'],
          options: ABC(
            'Sim, senão o parceiro fica bravo',
            'Não. Dado mínimo, ambiente de teste sem gente de verdade, contrato. Encarregado se for novo',
            'Sim, se apagar o CPF',
          ),
          correct: 'B',
          gabaritoCerto:
            'Tirar o CPF e deixar nome+telefone+endereço ainda identifica. Teste não se faz com a padaria inteira.',
          gabaritoErrado:
            'Tirar o CPF e deixar nome+telefone+endereço ainda identifica. Teste não se faz com a padaria inteira.',
        }),
      },
    ),
    S(
      10,
      'Pergunta 2',
      'teca-pensa',
      'O time quer um SaaS de disparo com servidor nos EUA. Primeiro passo?',
      'Segunda volta',
      { type: 'quiz' },
      {
        prompt:
          'O time quer um SaaS de disparo com servidor nos EUA. Primeiro passo?',
        scored: singleQuiz({
          items: ['c3-q2'],
          options: ABC(
            'Cadastra o cartão e sobe a lista',
            'Para. Transferência internacional. Jurídico / Encarregado olha cláusula ou adequação',
            'Só sobe se o logo for bonito',
          ),
          correct: 'B',
          gabaritoCerto: 'Bonito não é base legal. A nebula tem pedágio.',
          gabaritoErrado: 'Bonito não é base legal. A nebula tem pedágio.',
        }),
      },
    ),
    S(
      11,
      'Decisão só de máquina',
      'teca-explica',
      'Se um sistema sozinho decide coisa que mexe com a pessoa — bloquear cadastro, fila, crédito, “cliente risco” — ela pode pedir revisão. Você não responde “foi o algoritmo”.',
      'Continuar',
      {
        type: 'callout',
        body: 'Robô + botão revisão humana. Sempre.',
      },
    ),
    S(
      12,
      'Perfil',
      'teca-explica',
      'Montar perfil (“compra à noite”, “reclama”, “provável inadimplente”) é tratamento. Precisa de motivo, de dado mínimo, de não discriminar. Score escondido no canto da tela ainda é perfil.',
      'Continuar',
      {
        type: 'list',
        items: ['compra à noite', 'reclama', 'provável inadimplente'],
      },
    ),
    S(
      13,
      'IA na casa',
      'teca-explica',
      'Colar pedido de cliente, ticket ou folha no ChatGPT público é mandar dado para um operador que a empresa não contratou. Use só ferramenta liberada. Dado fictício quando for demo.',
      'Continuar',
      {
        type: 'callout',
        body: 'Prompt com gente de verdade = compartilhamento. Trate como tal.',
      },
    ),
    S(
      14,
      'Criança e adolescente',
      'teca-alerta',
      'Dado de criança pede cuidado extra. Clube infantil, foto de aniversário no salão, cadastro no cardápio. Sem o responsável, sem exposição. A ANPD já mostrou que multa isso — e alto.',
      'Continuar',
      {
        type: 'hero',
        heading: 'menor = extra',
        kicker: 'cuidado',
        badge: 'sem exposição',
      },
    ),
    S(
      15,
      'ECA Digital, uma frase',
      'teca-explica',
      'Em 2026 a ANPD também olha regras de criança no mundo digital. Você não precisa virar advogado do ECA. Precisa: não expor menor, não perfilar menor por esporte, chamar o Encarregado se o produto puxar menor para o centro.',
      'Continuar',
      {
        type: 'list',
        items: [
          'não expor menor',
          'não perfilar menor por esporte',
          'produto com menor no centro: Encarregado',
        ],
      },
    ),
    S(
      16,
      'Recap da mini-aula 2',
      'teca-explica',
      'Decisão de máquina tem revisão. Perfil é tratamento. IA pública não é pasta da empresa. Menor = extra. Em dúvida, Encarregado.',
      'Me pergunta',
      {
        type: 'pills',
        items: [
          'revisão humana',
          'perfil = tratamento',
          'IA pública não',
          'menor = extra',
        ],
      },
    ),
    S(
      17,
      'Pergunta 3',
      'teca-pensa',
      'O cliente pergunta por que o cadastro foi bloqueado “pelo sistema”. Você diz o quê?',
      'Ver a resposta',
      { type: 'quiz' },
      {
        prompt:
          'O cliente pergunta por que o cadastro foi bloqueado “pelo sistema”. Você diz o quê?',
        scored: singleQuiz({
          items: ['c3-q3'],
          options: ABC(
            '“Foi o robô, não tem jeito”',
            'Encaminha para revisão humana / canal de privacidade. Não fecha a porta',
            'Inventa um motivo para ele sair',
          ),
          correct: 'B',
          gabaritoCerto:
            'A lei fala em revisão de decisão só automatizada. “Foi o robô” é a Vaza de gravata.',
          gabaritoErrado:
            'A lei fala em revisão de decisão só automatizada. “Foi o robô” é a Vaza de gravata.',
        }),
      },
    ),
    S(
      18,
      'Pergunta 4',
      'teca-pensa',
      'Para treinar um bot, o time cola 50 tickets reais com nome e telefone numa IA pública. Pode?',
      'Caso final',
      { type: 'quiz' },
      {
        prompt:
          'Para treinar um bot, o time cola 50 tickets reais com nome e telefone numa IA pública. Pode?',
        scored: singleQuiz({
          items: ['c3-q4'],
          options: ABC(
            'Sim, é “só treino”',
            'Não. É compartilhar dado pessoal com quem a empresa não contratou',
            'Sim, se pedir “não treine com isso” no prompt',
          ),
          correct: 'B',
          gabaritoCerto:
            'Prompt mágico não é contrato. Dado fictício ou ferramenta liberada.',
          gabaritoErrado:
            'Prompt mágico não é contrato. Dado fictício ou ferramenta liberada.',
        }),
      },
    ),
    S(
      19,
      'O caso da nebula',
      'teca-incidente',
      'Segunda, 9h. Um fornecedor de disparo (servidor fora do Brasil) avisa: lista de 12 mil clientes da Padaria Estrela vazou. Tem menor no clube infantil. O CSV saiu de um e-mail pessoal de um colega.',
      'O que a gente faz',
      {
        type: 'cards',
        items: [
          { title: 'fornecedor fora', body: 'servidor fora do Brasil' },
          { title: '12 mil', body: 'clientes da Padaria Estrela' },
          { title: 'menor', body: 'clube infantil' },
          { title: 'e-mail pessoal', body: 'foi assim que o CSV saiu' },
        ],
      },
    ),
    S(
      20,
      'Ordem do caso (você)',
      'teca-explica',
      'Você não é o porta-voz. Você: 1) avisa segurança e Encarregado agora, 2) não reenvia o CSV, 3) conta como o arquivo saiu se você souber, 4) para de usar o fornecedor até o time falar. O relógio de 3 dias úteis já corre para a empresa.',
      'Continuar',
      {
        type: 'steps',
        numbered: true,
        items: [
          'Avisa segurança e Encarregado agora',
          'Não reenvia o CSV',
          'Conta como o arquivo saiu',
          'Para o uso do fornecedor até o time falar',
        ],
      },
    ),
    S(
      21,
      'Sanção, em número verdadeiro',
      'teca-explica',
      'A lei prevê advertência, multa de até 2% do faturamento no Brasil (teto R$ 50 milhões por infração), publicação, bloqueio, e, depois, até suspender atividade. Não é lenda.',
      'Continuar',
      {
        type: 'clock',
        heading: 'R$ 50 mi / infração',
        body: 'até 2% do faturamento no Brasil, teto por infração',
      },
    ),
    S(
      22,
      'A multa que saiu no jornal',
      'teca-explica',
      'Em agosto de 2026 a ANPD publicou multa de primeira instância de R$ 153,7 milhões ao TikTok, por falha com criança e adolescente. Ainda cabe recurso. Não é o valor da Altec. É o recado: a Agência multa, e menor pesa.',
      'Continuar',
      {
        type: 'callout',
        body: 'Primeira instância. Cabe recurso. Não analogia de valor para a Altec.',
      },
    ),
    S(
      23,
      'Boas práticas não são poster',
      'teca-explica',
      'Política de verdade, gente treinada, registro de quem fez este curso: isso a empresa pode mostrar. Ranking de badge no Slack, não. Este certificado é prova interna — who, when, what, pass.',
      'Continuar',
      {
        type: 'stones',
        items: ['who', 'when', 'what', 'pass'],
      },
    ),
    S(
      24,
      'Recap da mini-aula 3',
      'teca-nebula',
      'No caso: avisa, não espalha, para o sangramento. Multa é real, teto por infração. Menor pesa. Certificado é prova, não diploma da ANPD.',
      'Última prova',
      {
        type: 'pills',
        items: ['avisa', 'não espalha', 'teto por infração', 'menor pesa', 'prova interna'],
      },
    ),
    S(
      25,
      'Pergunta 5',
      'teca-pensa',
      'No caso da nebula, o colega quer “avisar os 12 mil pelo próprio Gmail para ser rápido”. E agora?',
      'Ver a resposta',
      { type: 'quiz' },
      {
        prompt:
          'No caso da nebula, o colega quer “avisar os 12 mil pelo próprio Gmail para ser rápido”. E agora?',
        scored: singleQuiz({
          items: ['c3-q5'],
          options: ABC(
            'Boa ideia, o prazo é curto',
            'Não. Comunicação de incidente é fluxo oficial. Gmail pessoal vaza de novo',
            'Manda só para os menores',
          ),
          correct: 'B',
          gabaritoCerto:
            'Prazo curto não autoriza um segundo vazamento. Encarregado conduz a comunicação.',
          gabaritoErrado:
            'Prazo curto não autoriza um segundo vazamento. Encarregado conduz a comunicação.',
        }),
      },
    ),
    S(
      26,
      'Pergunta 6',
      'teca-pensa',
      'Qual frase é verdadeira sobre a multa da LGPD?',
      'Ver a resposta',
      { type: 'quiz' },
      {
        prompt: 'Qual frase é verdadeira sobre a multa da LGPD?',
        scored: singleQuiz({
          items: ['c3-q6'],
          options: ABC(
            'A ANPD não multa de verdade',
            'Pode chegar a 2% do faturamento no Brasil, até R$ 50 milhões por infração',
            'Só multa se tiver morto',
          ),
          correct: 'B',
          gabaritoCerto:
            'Art. 52. Teto por infração. Sem lenda e sem pânico inventado.',
          gabaritoErrado:
            'Art. 52. Teto por infração. Sem lenda e sem pânico inventado.',
        }),
      },
    ),
    S(
      27,
      'Tarefa aplicada',
      'teca-pensa',
      'Ordene os 4 primeiros passos do caso da nebula.',
      'Fechar a nebula',
      { type: 'quiz' },
      {
        prompt: 'Ordene os 4 primeiros passos do caso da nebula.',
        scored: multiQuiz({
          items: [
            { id: 'c3-q7', kind: 'multi-part', mustInclude: ['avisar'] },
            { id: 'c3-q8', kind: 'multi-part', mustInclude: ['nao-reenviar'] },
            {
              id: 'c3-q9',
              kind: 'multi-part',
              mustInclude: ['contar', 'parar'],
              mustExclude: ['postar', 'gmail', 'imprensa'],
            },
          ],
          options: [
            opt('avisar', 'Avisar segurança e Encarregado'),
            opt('nao-reenviar', 'Não reenviar o CSV'),
            opt('contar', 'Contar como o arquivo saiu'),
            opt('parar', 'Parar o uso do fornecedor até o time falar'),
            opt('postar', 'Postar no grupo da loja'),
            opt('gmail', 'Mandar pelo Gmail pessoal'),
            opt('imprensa', 'Esperar a imprensa'),
          ],
          gabaritoCerto: 'Alarme, não megafone. Cofre, não viral.',
          gabaritoErrado: 'Alarme, não megafone. Cofre, não viral.',
        }),
      },
    ),
    S(
      28,
      'Os três cursos em uma tela',
      'teca-explica',
      'Escudo: o que é dado e quem é o dono. Cofre: sensível, senha, 3 dias úteis. Nebulosa: fluxo, nuvem, máquina, menor, multa. Você carrega os três.',
      'Continuar',
      {
        type: 'cards',
        items: [
          { title: 'Escudo Estelar', body: 'o que é dado e quem é o dono' },
          { title: 'Cofre Quântico', body: 'sensível, senha, 3 dias úteis' },
          { title: 'Rede Nebulosa', body: 'fluxo, nuvem, máquina, menor, multa' },
        ],
      },
    ),
    S(
      29,
      'Cartão de bolso',
      'teca-acena',
      'Bloqueia a tela. Não manda dado no grupo. Não cola gente em IA pública. Não exporta “a base toda”. Pedido de titular e vazamento: encaminha agora. Menor: extra. Em dúvida: Encarregado.',
      'Emitir certificado da trilha',
      {
        type: 'habits',
        items: [
          'Bloqueia a tela',
          'Não manda dado no grupo',
          'Não cola gente em IA pública',
          'Não exporta a base toda',
          'Pedido e vazamento: encaminha agora',
          'Menor: extra',
          'Em dúvida: Encarregado',
        ],
      },
    ),
    S(
      30,
      'Certificado da trilha',
      'teca-festeja',
      'Missão completa. Três certificados, um da trilha. É prova interna da Altec — não é carimbo da ANPD. Daqui a um ano a gente se vê no recert. Até lá, a Vaza continua procurando planilha. Não entrega.',
      'Baixar os certificados',
      { type: 'certificate', trilha: true },
    ),
  ],
};
